import { useEffect, useState } from 'react';

import { Box } from '@zillow/constellation-10';

import TimeConstants from '../../../constants/TimeConstants';

import { ControlledSearchBox } from '../../../components/ControlledSearchBox';

import { ActiveFilters, FiltersMenu } from './Filters';
import { ViewMode } from './ViewMode';

import type { FlexiblePropertiesViewMode } from '../../../constants/FlexiblePropertiesConstants';

type Props = {
  searchText: string;
  onSearchTextChange: (searchText: string) => void;
  viewMode: FlexiblePropertiesViewMode;
  onViewModeChange: (viewMode: FlexiblePropertiesViewMode) => void;
  isArchived?: boolean;
  onArchivedChange?: (isArchived: boolean) => void;
  isLoading?: boolean;
  isSearching?: boolean;
};

export const Toolbar = ({
  searchText,
  onSearchTextChange,
  viewMode,
  onViewModeChange,
  isArchived = false,
  onArchivedChange = () => undefined,
  isLoading = false,
  isSearching = false,
}: Props) => {
  const [searchInput, setSearchInput] = useState(searchText);

  useEffect(() => {
    setSearchInput(searchText);
  }, [searchText]);

  return (
    <Box
      data-testid="FlexiblePropertiesPage-Toolbar"
      css={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        flexDirection: { base: 'column', xl: 'row' },
        marginTop: { base: '600', lg: '900' },
        gap: { base: '400', xl: '600' },
        marginBottom: '600',
      }}
    >
      <Box
        data-testid="FlexiblePropertiesPage-Filters"
        css={{
          display: 'flex',
          alignItems: 'center',
          flex: { xl: '1' },
          width: { base: '100%', xl: 'auto' },
          minWidth: 0,
        }}
      >
        <Box
          css={{
            width: { base: '100%', xl: '309px' },
            flexShrink: 0,
            minWidth: 0,
          }}
        >
          <ControlledSearchBox
            value={searchInput}
            onChange={setSearchInput}
            onSearch={onSearchTextChange}
            placeholder="Search properties"
            isSearching={isSearching}
            iconSize="sm"
            debounceMilliseconds={TimeConstants.SELECTION_DEBOUNCE_TIME_MS}
          />
        </Box>
      </Box>

      <Box css={{ display: 'flex', gap: '400', width: { base: '100%', xl: 'auto' } }}>
        <ActiveFilters isArchived={isArchived} onArchivedChange={onArchivedChange} isLoading={isLoading} />

        <FiltersMenu isArchived={isArchived} onArchivedChange={onArchivedChange} isLoading={isLoading} />

        <ViewMode viewMode={viewMode} onViewModeChange={onViewModeChange} isLoading={isLoading} />
      </Box>
    </Box>
  );
};
